<mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" class="px-15" fxLayoutAlign="space-between center">
        <span class="title dialog-title">Dettagli {{ dettagliQuadroRs.cellId | removeSpecialChars }} </span>
        <button mat-icon-button mat-dialog-close (click)="dialogRef.close()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar-row>
</mat-toolbar>

<mat-card-content>
    <div class="cssWidgetWrapper p-24 pb-8" fxLayout="column" fxLayoutGap="15px">
        <div fxFill fxLayout="row" fxLayoutAlign="space-between center">
            <span>Importo presente nelle fatture ricevute</span>
            <strong [innerText]="importoPresenteNelleFattureRicevute | currency : 'EUR' : 'symbol' : '1.0-0'"></strong>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
            <span class="mt-16" fxFlex="calc(55% - 30px)">Importo inserito manualmente dal cliente</span>
            <mat-form-field fxFlex="calc(20% - 30px)" color="accent">
                <input
                    style="text-align: right; font-weight: bold"
                    [disabled]="dettagliQuadroRs.statoDichiarazione === statoDichiarazioneTemplate.Chiusa"
                    matInput
                    min="0"
                    type="number"
                    [(ngModel)]="importoNonPresenteNelleFattureRicevute" />
                <span matSuffix><strong>&nbsp;€</strong> </span>
            </mat-form-field>
        </div>
        <!-- <mat-divider></mat-divider> -->
        <div fxLayout="row" fxLayoutAlign="space-between  center" fxLayoutGap="30px">
            <span>Totale</span>
            <strong [innerText]="importoPresenteNelleFattureRicevute + importoNonPresenteNelleFattureRicevute | currency : 'EUR' : 'symbol' : '1.0-0'"></strong>
        </div>
        <mat-card-actions class="mb-0 pb-0" align="right"
            ><button
                color="accent"
                [disabled]="dettagliQuadroRs.statoDichiarazione === statoDichiarazioneTemplate.Chiusa"
                (click)="onSalvaModifiche()"
                mat-raised-button>
                Salva
            </button></mat-card-actions
        >
    </div>
</mat-card-content>
